<template>
	<div>
		<h3 class="mt-2 mb-3">Service Lost Settings</h3>
		
		<h5>Current Service Lost Parameter : {{range}} Months</h5>
		<p>The number shows the allocated difference time between its last service date of a vehicle to be determined as lost vehicle.</p>

		<div class="mt-3 row">
			<div class="col-12 col-md-3 col-sm-5 mt-auto mb-auto">
				<h6 style="color:black">Change Service Lost Parameter (In Months) : </h6>
			</div>
			<div class="col-md-9 col-sm-7 col-12">
				<input type="text" class="form-control" v-model="rangeChange"/>
			</div>
			<div class="offset-md-3 offset-sm-5 col-md-9 col-sm-7 pt-0 pb-0 pl-2">
				<button class="btn btn-primary" type="button" @click="updateServiceLost">Submit Changes</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			range : 0,
			rangeChange : 0
		}
	},
	mounted () {
		this.getServiceLost()
	},
	methods : {
		getServiceLost() {
			this.$http.get('/api/setting/get-service-lost')
			.then((resp) => {
				this.range = resp.data.data.value
				this.rangeChange = this.range
			})
			.catch((err) => {
				console.log(err)
			})
		},
		updateServiceLost() {
			this.$http.post('/api/setting/update-service-lost', {value : this.rangeChange})
			.then((resp) => {
				this.getServiceLost()
			})
			.catch((err) => {
				console.log(err)
			})
		}
	}
}
</script>